import { createContext } from "react";
import type {
  SubscriptionHistoryEntry,
  UpdateProfilePayload,
} from "../../../api/auth";
import { AccountRole } from "../utils/types";

export interface AuthUser {
  token: string;
  userId: string;
}

export interface AccountDetails {
  subscriptionHistory?: SubscriptionHistoryEntry[];
  firstName?: string;
  secondName?: string;
  lastName?: string;
  email: string;
  phoneNumber?: string;
  companyName?: string;
  companyRegistrationNumber?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  shippingHeavyPrice?: number;
  shippingLightPrice?: number;
}

export interface AuthContextType {
  user: AuthUser | null;
  token: string | null;
  userId: string | null;
  role: AccountRole | null;
  isAdmin: boolean;
  isEmployee: boolean;
  isBusiness: boolean;
  isSocial: boolean;
  isSuperUser: boolean;
  isAuthenticated: boolean;
  hasCSASubscription: boolean;
  details: AccountDetails | null;
  detailsLoading: boolean;
  detailsError: unknown;
  refetchDetails: () => Promise<void>;
  /** PATCH profile then refetch `details`. Throws on API error (e.g. axios). */
  saveAccountProfile: (payload: UpdateProfilePayload) => Promise<void>;
  /** Call after login/logout so navbar and other consumers update immediately. */
  refreshAuth: () => void;
  /** Clear auth state and localStorage token/user. */
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);
